import {
  MrfiktivBlueprintElementViewmodelGen,
  MrfiktivCoordinatesDtoGen,
  MrfiktivCoordinatesViewModelGen,
  MrfiktivPositionDtoGen,
  MrfiktivPositionViewModelGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { Zones } from "@/models/zones.entity";
import { IZone, Zone } from "@/models/zone.entity";
import { ZoneTypeEnum } from "@/lib/enum/zone-type.enum";

class ReportPositionBase implements MrfiktivPositionViewModelGen {
  /** The blueprint element used for positioning */
  blueprint: MrfiktivBlueprintElementViewmodelGen;

  /** Coordinates on the blueprint */
  coordinates?: MrfiktivCoordinatesViewModelGen;

  /** Optional meta information */
  meta?: string;

  constructor(data: MrfiktivPositionViewModelGen) {
    this.blueprint = data.blueprint;
    this.coordinates = data.coordinates;
    this.meta = data.meta;
  }

  get dto(): MrfiktivPositionDtoGen {
    const coordinates: MrfiktivCoordinatesDtoGen | undefined = this.coordinates
      ? { x: this.coordinates.x, y: this.coordinates.y }
      : undefined;

    const dto: MrfiktivPositionDtoGen = {
      blueprintId: this.blueprint?.id,
      coordinates: coordinates,
      meta: this.meta
    };

    return dto;
  }

  /**
   * Get all hit zones for the current report position
   */
  get hitZones(): IZone[] {
    if (!this.coordinates) {
      return [];
    }
    const zoneEntities = (this.blueprint.zones || []).map(z => new Zone(z));
    const zones = new Zones(zoneEntities);
    const hitZones = zones.getHitZones(this.coordinates?.x, this.coordinates?.y);

    return hitZones;
  }

  getHitZonesByType(type: ZoneTypeEnum): IZone[] {
    return this.hitZones.filter(z => z.type === type);
  }
}

type IReportPosition = ReportPositionBase;
const ReportPosition = ReportPositionBase;

export { IReportPosition, ReportPosition };
